import { AxiosError } from 'axios';
import { FormApiService, ItemCommandResult } from 'src/common/api-service';
import { CheckOtpBody, SendOtpBody } from './types';

export class OtpApiService extends FormApiService {
  constructor() {
    super('otp');
  }

  public async sendOtp(data: SendOtpBody): Promise<ItemCommandResult<string>> {
    try {
      return await this.post(data, `sendOtp`);
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<string>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async checkOtp(data: CheckOtpBody): Promise<ItemCommandResult<boolean>> {
    try {
      return await this.post(data, `checkOtp`);
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<boolean>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}
